import product_images from "./images/index.jsx";

export const singleProductData = [
  {
    id: "CJJT1244965",
    name: "Butterfly Quilling Illustration", // show when we open single product
    company: "eosp",
    price: 2099,
    colors: ["#ffc0cb", "#0000ff", "#cdd0d0"],
    description:
      "20 Inch Butterfly Quilling Illustration Material Pack Slot",
    category: "decoration",
    featured: true,
    stock: 7,
    reviews: 25,
    stars: 4.8,
    image: [
      { url: product_images.product1.product1_1 },
      { url: product_images.product1.product1_2 },
      { url: product_images.product1.product1_3 },
      { url: product_images.product1.product1_4 },
    ],
  },
  {
    id: "CJMY1687359",
    name: "Cute Bunny Hat", // show when we open single product
    company: "discountify",
    price: 3499,
    colors: ["#000", "#22d3ef"],
    description:
      "Plush Cartoon Cat Dog Rabbit Ears Cute Easter decoration Hat Head Cover Pets Products",
    category: "fashion",
    stock: 7,
    reviews: 32,
    stars: 5,
    image: [
      { url: product_images.product2.product2_1 },
      { url: product_images.product2.product2_2 },
      { url: product_images.product2.product2_3 },
    ],
  },
  {
    id: "CJCF117252405EV",
    name: "Man Prescription Glasses", // show when we open single product
    company: "easy order",
    price: 3499,
    colors: ["#22d3ef", "#cdd0d0"],
    description:
      "Sunglasses Driving Special Anti-ultraviolet Sunglasses For Day And Night",
    category: "fashion",
    stock: 4,
    reviews: 102,
    stars: 4.6,
    image: [
      { url: product_images.product3.product3_1 },
      { url: product_images.product3.product3_2 },
      { url: product_images.product3.product3_3 },
      { url: product_images.product3.product3_4 },
    ],
  },
  {
    id: "CJZBNSSZ00061",
    name: "Digital Watches", // show when we open single product
    company: "discountify",
    price: 2800,
    colors: ["#000", "#ffc0cb", "#cdd0d0"],
    description:
      "Vintage clock fashion digital wall clock",
    category: "accessories",
    stock: 7,
    reviews: 70,
    stars: 4.6,
    image: [
      { url: product_images.product4.product4_1 },
      { url: product_images.product4.product4_2 },
      { url: product_images.product4.product4_3 },
      { url: product_images.product4.product4_4 },
    ],
  },

  {
    id: "CJEJ1596832",
    name: "Headphones", // show when we open single product
    company: "eosp",
    price: 3000,
    colors: ["#000", "#cdd0d0"],
    description:
      "Wireless Light-emitting Bluetooth Headphones",
    category: "fashion",
    stock: 6,
    reviews: 50,
    stars: 5.0,
    image: [
      { url: product_images.product5.product5_1 },
      { url: product_images.product5.product5_2 },
      { url: product_images.product5.product5_3 },
      { url: product_images.product5.product5_4 },
    ],
  },

  {
    id: "CJJJCWMY01530",
    name: "Cat Supplies", // show when we open single product
    company: "simple ship",
    price: 1600,
    colors: ["#ffc0cb", "#cdd0d0"],
    description:
      "Vest-style Chest Strap For Cats",
    category: "fashion",
    stock: 3,
    reviews: 36,
    stars: 4.3,
    image: [
      { url: product_images.product6.product6_1 },
      { url: product_images.product6.product6_2 },
      { url: product_images.product6.product6_3 },
    ],
  },
  
  {
    id: "CJDS1094193",
    name: "Man T-shirts", // show when we open single product
    company: "discountify",
    price: 2550,
    colors: ["#cdd0d0", "#000"],
    description:
      "Round Neck Korean Short-Sleeved T-Shirt Men'S Color Matching Men'S T-Shirt Clothes",
    category: "fashion",
    stock: 6,
    reviews: 30,
    stars: 4.7,
    image: [
      { url: product_images.product7.product7_1 },
      { url: product_images.product7.product7_2 },
      { url: product_images.product7.product7_3 },
      { url: product_images.product7.product7_4 },
    ],
  },
  
  {
    id: "CJJJJTJT03804",
    name: "decoration", // show when we open single product
    company: "simple ship",
    price: 5000,
    colors: ["#000", "#cdd0d0"],
    description:
      "Home/Office decoration",
    category: "decoration",
    stock: 8,
    reviews: 120,
    stars: 4.0,
    image: [
      { url: product_images.product8.product8_1 },
      { url: product_images.product8.product8_2 },
      { url: product_images.product8.product8_3 },
      { url: product_images.product8.product8_4 },
    ],
  },
  
  {
    id: "CJWJWJJM00057",
    name: "toys", // show when we open single product
    company: "discountify",
    price: 2299,
    colors: ["#ffc0cb"],
    description:
      "Children's intelligence puzzle toys educational toys",
    category: "toys",
    stock: 5,
    reviews: 59,
    stars: 4.6,
    image: [
      { url: product_images.product9.product9_1 },
      { url: product_images.product9.product9_2 },
      { url: product_images.product9.product9_3 },
      { url: product_images.product9.product9_4 },
    ],
  },
  
  {
    id: "CJWJWJMR00206",
    name: "toys", // show when we open single product
    company: "discountify",
    price: 2299,
    colors: ["#ff0000", "#22d3ef", "#ffc0cb"],
    description:
      "Creative Animal Plush toys",
    category: "toys",
    stock: 6,
    reviews: 79,
    stars: 5.0,
    image: [
      { url: product_images.product10.product10_1 },
      { url: product_images.product10.product10_2 },
      { url: product_images.product10.product10_3 },
      { url: product_images.product10.product10_4 },
    ],
  },
  
];
